function createStory(shortName, title, preview, story) {
    return {
        shortName: shortName,
        title: title,
        preview: preview,
        story: story
    };
}

export default createStory;